(function () {
  function initReveal() {
    var toObserve = [];

    var staggerGroups = [
      { container: '.content-blocks__grid', child: '.content-blocks__item' },
      { container: '.faq__content', child: '.accordion' },
    ];

    staggerGroups.forEach(function (g) {
      document.querySelectorAll(g.container).forEach(function (container) {
        container.querySelectorAll(g.child).forEach(function (child, i) {
          child.classList.add('reveal');
          child.style.animationDelay = i * 0.08 + 's';
          toObserve.push(child);
        });
      });
    });

    // Product description: stagger each paragraph and list item in sequence
    document.querySelectorAll('.product-info .prose').forEach(function (prose) {
      prose.querySelectorAll(':scope > p, :scope li').forEach(function (el, i) {
        el.classList.add('reveal');
        el.style.animationDelay = i * 0.08 + 's';
        toObserve.push(el);
      });
    });

    document.querySelectorAll('.section-header, .prose > h2, .prose > h3').forEach(function (el) {
      if (!el.classList.contains('reveal')) {
        el.classList.add('reveal');
        toObserve.push(el);
      }
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    toObserve.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();
